module.exports = "/fonts/vendor/boxicons/boxicons.woff?86708f260a765d37cce51959dc4c097d";